'use strict';

var createAgGridFilterPersistence = require('../agGridFilterPersistence').createAgGridFilterPersistence;

var gridGraphCtrl = ["graphDataFactory", "$scope", "gridConfiguration", "$timeout", "$translate", function (graphDataFactory, $scope, gridConfiguration, $timeout, $translate) {
    var _this = this;
    _this.waitingData = true;
    _this.cssPanel = "";
    _this.cssObject = "";
    _this.edit = false;
    var gridIdSuffix = _this.graphDomSuffix || '';
    _this.myObjectId = "gridGraph-".concat(_this.element.id).concat(gridIdSuffix);
    _this.myObject = "#".concat(_this.myObjectId);

    _this.maximize = _this.maximize || false; // Si es true se muestra el botón de maximizar, hay que dejarle el lugar porque el botón esta en el padre en view. 

    function layoutH() {
        var v = _this.layoutViewport;
        if (v && v.height > 0) return v.height;
        return window.innerHeight;
    }

    function isMaximizeViewport() {
        return _this.layoutViewport && _this.layoutViewport.height > 0;
    }

    _this.element.partsOfWindowWidth = _this.element.partsOfWindowWidth || 1;
    _this.element.partsOfWindowHeight = _this.element.partsOfWindowHeight || 1;
    _this.data = []
    _this.columnDefs = [];
    _this.agGridObject = undefined;
    _this.initState = false;
    _this.restoringGridPreferences = false;
    _this.hasActiveFilters = false;

    const cloneColumnState = (state) => {
        if (!state) return null;
        try {
            return JSON.parse(JSON.stringify(state));
        } catch (e) {
            return null;
        }
    };

    // Los tableros clonados reutilizan el id de la grilla. La clave incluye el
    // id del tablero para que columnas y filtros no se pisen entre sí.
    const gridPrefsStorageKey = () => {
        const elementId = _this.element && _this.element.id ? _this.element.id : '';
        const graphId = _this.graphId || '';
        if (graphId && elementId) {
            return 'gridGraphFormId'.concat(graphId, 'gridId', elementId);
        }
        return 'gridGraphFormId'.concat(elementId);
    };

    const canPersistColumnChange = (type) => {
        return type !== 'columnEverythingChanged'
            && !_this.restoringGridPreferences
            && !_this.waitingData
            && _this.initState;
    };

    _this.filterPrefs = createAgGridFilterPersistence({
        $timeout,
        getFormId: () => _this.element && _this.element.id,
        hasTaskId: () => false,
        getGridOptions: () => _this.gridOptions,
        getGridInitState: () => _this.initState,
        getGridRestoringPreferences: () => _this.restoringGridPreferences,
        setGridRestoringPreferences: (value) => { _this.restoringGridPreferences = value; },
        getLocalStorageKey: () => gridPrefsStorageKey(),
        canPersistExtra: () => !_this.edit && !_this.waitingData && _this.element && _this.element.id,
        refreshData: () => { }
    });

    _this.gridOptions = {
        rowHeight: 35,
        rowSelection: 'single',
        suppressRowClickSelection: true,
        columnDefs: _this.columnDefs,
        enableFilter: true,
        enableSorting: true,
        showToolPanel: _this.editenabled && _this.edit,
        enableColResize: true,
        angularCompileRows: true,
        angularCompileFilters: true,
        angularCompileHeaders: true,
        localeText: gridConfiguration.localeText,
        onRowClicked: function (params) {
            var api = _this.gridOptions.api;
            if (!api || !params.node) {
                return;
            }
            if (api.isNodeSelected(params.node)) {
                api.deselectNode(params.node);
            } else {
                api.deselectAll();
                api.selectNode(params.node);
            }
        },
        onAfterFilterChanged: function () {
            _this.filterPrefs.onFilterChanged();
            _this.updateActiveFiltersState();
        },
        onGridReady: function () {
            _this.restoringGridPreferences = true;
            if (_this.edit && _this.element.savedState) {
                try {
                    _this.gridOptions.columnApi.setState(_this.element.savedState);
                } catch (e) {
                    console.error('Error al restaurar estado de edición:', e);
                }
            }

            _this.gridOptions.api.addGlobalListener(function (type, event) {
                if (type === 'afterFilterChanged') {
                    _this.filterPrefs.onFilterChanged();
                    _this.updateActiveFiltersState();
                }
                if (type.indexOf('column') >= 0) {
                    if (canPersistColumnChange(type)) {
                        if (_this.edit) {
                            _this.element.savedState = cloneColumnState(_this.gridOptions.columnApi.getState());
                            _this.element.savedStateUpdatedAt = new Date().toISOString();
                        } else if (_this.element.id && _this.filterPrefs.canPersist()) {
                            _this.filterPrefs.persistToLocalStorage();
                        }
                    }
                    _this.initState = true;
                }
            });

            $timeout(function () {
                _this.restoringGridPreferences = false;
                _this.initState = true;
            }, 200);

            // Sincronizar visibilidad del tool panel (Columna, Valor Columna, grupo columna) con modo edición
            if (_this.gridOptions.api.showToolPanel) {
                _this.gridOptions.api.showToolPanel(_this.editenabled && _this.edit);
            }
        }
    };

    _this.hasAppliedGridFilters = function () {
        if (!_this.filterPrefs || !_this.gridOptions || !_this.gridOptions.api) {
            return false;
        }
        const fm = _this.filterPrefs.buildFilterModelFromGrid(
            _this.gridOptions.api.getFilterModel && _this.gridOptions.api.getFilterModel()
        );
        return fm && typeof fm === 'object' && Object.keys(fm).length > 0;
    };

    _this.updateActiveFiltersState = function () {
        _this.hasActiveFilters = _this.hasAppliedGridFilters();
    };

    _this.toggleEdit = () => {
        if (_this.waitingData) {
            return;
        }
        if (_this.edit) {
            _this.edit = false;
            if (_this.gridOptions.api && _this.gridOptions.api.showToolPanel) {
                _this.gridOptions.api.showToolPanel(false);
            }
            return;
        }
        _this.loadMe(true, { restoreEditState: true }).then(() => {
            $timeout(() => {
                _this.edit = true;
                if (_this.gridOptions.api && _this.gridOptions.api.showToolPanel) {
                    _this.gridOptions.api.showToolPanel(true);
                }
            }, 0);
        });
    };

    function makeColumnDefs() {
        const docsFilterWith = $translate.instant('DASHBOARD.DASH_GRAPH.GRID.DOCS_FILTER_WITH');
        const docsFilterWithout = $translate.instant('DASHBOARD.DASH_GRAPH.GRID.DOCS_FILTER_WITHOUT');

        function getDocsFromRow(data, fieldName) {
            if (!data || !fieldName) {
                return [];
            }
            if (data.payload && data.payload[fieldName]) {
                const docsNode = data.payload[fieldName];
                const docs = docsNode && docsNode.value;
                return Array.isArray(docs) ? docs : [];
            }
            const raw = data[fieldName];
            if (Array.isArray(raw)) {
                return raw;
            }
            if (raw && typeof raw === 'object' && Array.isArray(raw.value)) {
                return raw.value;
            }
            if (typeof raw === 'string') {
                try {
                    const parsed = JSON.parse(raw);
                    if (Array.isArray(parsed)) {
                        return parsed;
                    }
                    if (parsed && Array.isArray(parsed.value)) {
                        return parsed.value;
                    }
                } catch (e) {
                    return [];
                }
            }
            return [];
        }

        function docsFilterGetter(params) {
            const docs = getDocsFromRow(params.data, params.colDef.field);
            return docs.length > 0 ? docsFilterWith : docsFilterWithout;
        }

        function myGetter(params) {
            // console.log('myGetter params', params)
            if (params.data && params.data[params.colDef.field]) {
                return params.data[params.colDef.field];
            }
            return "";
        };
        function myGetterJSON(params) {
            if (params.data && params.data[params.colDef.field]) {
                return JSON.stringify(params.data[params.colDef.field]);
            }
            return JSON.stringify(null);
        };

        function getAlign(field) {
            if (field.templateData && field.templateData.align) {
                if (field.templateData.align === 'left') return 'my-left-aligned-cell';
                if (field.templateData.align === 'center') return 'my-center-aligned-cell';
                if (field.templateData.align === 'right') return 'my-right-aligned-cell';
            };

            switch (field.type) {
                case 'text':
                    return 'my-left-aligned-cell'
                case 'number':
                case 'autonumeric':
                case 'formula':
                case 'graphColumn':
                    return 'my-right-aligned-cell';
                case 'date':
                case 'timestamp':
                case 'time':
                    return 'my-center-aligned-cell';
            }
            return 'my-left-aligned-cell';
        }

        function getRenderSpec(field, tempObject, lockedByHtmlFormId) {

            if (field.type === 'number') {
                tempObject.filter = 'number';
                tempObject.cellRenderer = gridConfiguration.numberGraphRenderer;
                tempObject.formData = field;
                tempObject.cellClass = getAlign(field);
            } else if (field.type === 'autonumeric') {
                tempObject.filter = 'text';
                tempObject.cellRenderer = gridConfiguration.numberGraphRenderer;
                tempObject.formData = field;
                tempObject.cellClass = getAlign(field);
            } else if (field.type === 'formula') {
                tempObject.filter = 'number';
                tempObject.valueGetter = gridConfiguration.formulaGraphGetter;
                tempObject.formData = field;
                tempObject.cellClass = getAlign(field);
            }
            if (field.type === 'history') {
                tempObject.cellRenderer = function () {
                    const fieldData = JSON.stringify(field);
                    // console.log('fieldData', fieldData)
                    return "<validate-history-graph-bis data='data' field='" + fieldData + "'></validate-history-graph-bis>";
                }
                tempObject.valueGetter = myGetter;
                tempObject.field = field.id;
                tempObject.suppressMenu = true;
                tempObject.suppressSorting = true;
                tempObject.formData = field;
                tempObject.cellClass = 'my-center-aligned-cell';
            }
            if (field.type === 'simplelist' && field.subItems == "modal") {
                tempObject.cellRenderer = function () {
                    const fieldData = JSON.stringify(field);
                    return "<simple-list-graph data='data' field='" + fieldData + "'></simple-list-graph>";
                }
                tempObject.valueGetter = [];
                tempObject.field = field.id;
                tempObject.suppressMenu = true;
                tempObject.suppressSorting = true;
                tempObject.formData = field;
                tempObject.cellClass = 'my-center-aligned-cell';
            }

            if (field.type === 'member') {
                tempObject.valueGetter = myGetter;
            }

            if (field.type === 'sign') {
                tempObject.cellRenderer = gridConfiguration.signRenderer;
                tempObject.suppressMenu = true;
                tempObject.suppressSorting = true;
                tempObject.valueGetter = myGetter;
            }
            if (field.type === 'geo') {
                tempObject.cellRenderer = function (params) {
                    params.value = JSON.parse(params.value);
                    if (params.value) {
                        return `<div class="grid--renderer--icon-data">
                                    <div class="grid--renderer--icon-data--icon">
                                        <i class="icon ion-android-pin" ></i>
                                    </div>
                                    <span class="grid--renderer--icon-data--label">
                                        <a target="_blank" href="https://www.google.com.ar/maps/search/${params.value}">${params.value}</a>
                                    </span>
                                </div>`;
                    }
                    return;
                }
                tempObject.width = 200;
                tempObject.valueGetter = myGetterJSON;
                tempObject.suppressMenu = true;
                tempObject.suppressSorting = true;
            }
            if (field.type === 'date') {
                tempObject.cellRenderer = gridConfiguration.dateRenderer;
                tempObject.filter = gridConfiguration.dateFilter;
                tempObject.comparator = gridConfiguration.dateComparator;
                tempObject.cellClass = getAlign(field);
                tempObject.formData = field;
                const isCombinedDs = dsCfg && ['relation', 'leftRelation', 'concatenate', 'integration'].includes(dsCfg.type);
                tempObject.showDateTime = !!(isCombinedDs && !field.localeAndCutDate);
            }
            if (field.type === 'time') {
                //tempObject.cellRenderer = gridConfiguration.timeRenderer;
                tempObject.filter = undefined;
                tempObject.suppressMenu = true;
                tempObject.comparator = gridConfiguration.dateComparator;
                tempObject.cellClass = getAlign(field);
            }
            if (field.type === 'timestamp') {
                tempObject.cellRenderer = gridConfiguration.timestampRenderer;
                tempObject.suppressMenu = true;
                tempObject.comparator = gridConfiguration.dateComparator;
                tempObject.cellClass = getAlign(field);
                tempObject.formData = field;
            }
            if (field.type === 'checkbox') {
                tempObject.filter = "set";
                tempObject.filterParams["values"] = [true, false];
                tempObject.cellRenderer = gridConfiguration.checkboxRenderer;
            }
            if (field.id === 'lockedBy') {
                tempObject.cellRenderer = gridConfiguration.linkLockedByRenderer;
                tempObject.valueGetter = myGetter;
                tempObject.width = 120;
                tempObject.cellClass = 'my-center-aligned-cell';
                tempObject.filter = 'text';
                tempObject.lockedByHtmlFormId = lockedByHtmlFormId != null && lockedByHtmlFormId !== '' ? lockedByHtmlFormId : 0;
            }
            if (field.type === 'docs' || field.type === 'photo' || field.type === 'video') {
                if (field.subItems && field.subItems != "") {
                    tempObject.cellRenderer = field.type === 'photo' ? gridConfiguration.imgRenderer : gridConfiguration.linkRenderer;
                    tempObject.valueGetter = myGetter;
                    tempObject.suppressSorting = true;
                    tempObject.suppressMenu = true;
                    tempObject.cellClass = 'my-center-aligned-cell';
                } else if (field.type === 'docs') {
                    tempObject.cellRenderer = gridConfiguration.docsRenderer;
                    tempObject.valueGetter = docsFilterGetter;
                    tempObject.filter = 'set';
                    tempObject.filterParams.values = [docsFilterWith, docsFilterWithout];
                    tempObject.suppressSorting = true;
                    tempObject.cellClass = 'my-center-aligned-cell';
                } else {
                    tempObject.cellRenderer = gridConfiguration.galleryRenderer;
                    tempObject.valueGetter = myGetterJSON;
                    tempObject.suppressSorting = true;
                    tempObject.suppressMenu = true;
                    tempObject.cellClass = 'my-center-aligned-cell';
                }
            }
            if (field.type === 'graphColumn') {
                tempObject.cellClass = getAlign(field);
            }
            // linkHTML / type linkReport: vincular reporte en grilla (prioridad sobre text)
            if (field.linkHTML || field.type === 'linkReport') {
                tempObject.cellRenderer = gridConfiguration.linkReportHTMLRenderer;
                tempObject.width = 60;
                tempObject.cellClass = 'my-center-aligned-cell';
                return tempObject;
            }
            if (field.type === 'text') {
                tempObject.valueGetter = myGetter;
                tempObject.cellClass = getAlign(field);
                tempObject.cellRenderer = gridConfiguration.textWithLinksRenderer;
                return tempObject;
            }
            // Texto libre sin renderer propio (select, multiple, member, graphColumn, etc.):
            // detectar URLs y mostrarlas como links clicables.
            if (!tempObject.cellRenderer) {
                tempObject.cellRenderer = gridConfiguration.textWithLinksRenderer;
            }
            return tempObject
        }

        function getHeaders(elements, lockedByHtmlFormId) {
            const processed = new Set();
            var resolvedLockedByFormId = lockedByHtmlFormId != null && lockedByHtmlFormId !== '' ? lockedByHtmlFormId : 0;

            function buildColumn(field) {
                const colField = Object.assign({}, field);
                if (!colField.type && ['_createdAt', '_startedAt', 'closedAt', 'validateDate'].includes(colField.id)) {
                    colField.type = 'timestamp';
                }
                const colDef = {
                    headerName: colField.name || colField.label,
                    fieldType: colField.type || colField.label || 'text',
                    field: colField.name,
                    width: 150,
                    filterParams: { cellHeight: 20, apply: true, newRowsAction: 'keep' },
                };
                return getRenderSpec(colField, colDef, resolvedLockedByFormId);
            }

            function processElement(el, lst) {
                const key = el.name || el.id;
                if (processed.has(key)) return;

                if ((el.type === "simplelist" || el.type === "group") &&
                    el.subItemsCols === "expand" && el.nodes && typeof el.nodes === 'object') {
                    Object.values(el.nodes).forEach(subEl => {
                        processElement(subEl, lst);
                    });
                } else {
                    lst.push(buildColumn(el));
                    processed.add(key);
                }
            }

            return elements.reduce((lst, el) => {
                processElement(el, lst);
                return lst;
            }, []);
        }


        let dsEl = graphDataFactory.getElementDataSourceById(
            _this.element.templateData.datasourceElementId
        );
        let dsCfg = dsEl && dsEl.templateData && dsEl.templateData.datasource;
        let lockedByHtmlFormId = 0;
        if (dsCfg && (dsCfg.type === 'query' || dsCfg.type === 'action') && dsCfg.formId) {
            lockedByHtmlFormId = dsCfg.formId;
        }

        function elementsWithIds(map) {
            return Object.keys(map || {}).map((key) => {
                const el = map[key];
                if (!el) return el;
                return el.id ? el : Object.assign({}, el, { id: key });
            });
        }

        let listElements = [];
        listElements = elementsWithIds(dsCfg && dsCfg.elements);
        listElements = listElements.concat(elementsWithIds(dsCfg && dsCfg.moreFields));

        _this.columnDefs = getHeaders(listElements, lockedByHtmlFormId);
    }

    _this.exportExcel = function () {
        _this.gridOptions.api.setRowData(_this.selectedItems);
        window.exportarAgGridAExcel(_this.gridOptions.api, _this.element.name.replace(' ', '_') + '.xlsx');
        _this.gridOptions.api.setRowData(_this.itemsBkp);
    };

    _this.exportCSV = function () {
        _this.gridOptions.api.setRowData(_this.selectedItems);
        _this.gridOptions.api.exportDataAsCsv({
            fileName: _this.element.name.replace(' ', '_') + '.csv'
        });
        _this.gridOptions.api.setRowData(_this.itemsBkp);
    };

    _this.resetFilters = function () {
        if (_this.gridOptions && _this.gridOptions.api) {
            _this.filterPrefs.reset();
            _this.gridOptions.api.setFilterModel(null);
            if (_this.filterPrefs.canPersist()) {
                _this.filterPrefs.persistToLocalStorage();
            }
            _this.updateActiveFiltersState();
        }
    };

    _this.resetColumnsState = function () {
        if (_this.element.id) {
            const localStorageKey = _this.filterPrefs.getLocalStorageKey();
            if (localStorage.hasOwnProperty(localStorageKey)) {
                localStorage.removeItem(localStorageKey);
                _this.filterPrefs.clearAllState();
                _this.loadMe(true);
            }
        }
    }

    const relayoutGrid = () => {
        const api = _this.gridOptions && _this.gridOptions.api;
        if (!api) return;
        api.doLayout();
        api.refreshView();
    };

    _this.loadMe = function (forceUpdateData = false, options) {
        const restoreEditState = !!(options && options.restoreEditState);
        _this.waitingData = true;
        _this.cssPanel = "width:100%;";

        let height;
        if (isMaximizeViewport()) {
            height = layoutH() - 24;
        } else if (_this.element.heightMode === 'percentage' && _this.element.heightPercentage !== undefined) {
            let percentage = parseFloat(_this.element.heightPercentage) || 100;
            percentage = Math.max(0, Math.min(100, percentage));
            height = (layoutH() * percentage / 100) - 20;
        } else {
            let parts = parseFloat(_this.element.partsOfWindowHeight) || 1;
            height = (layoutH() / parts) - 20;
        }
        var gridChrome = isMaximizeViewport() ? 0 : 35;
        _this.cssObject = "height:".concat((height - gridChrome).toFixed(), "px;");

        if (!_this.element.templateData.datasourceElementId) {
            _this.waitingData = false;
            return Promise.resolve();
        }

        return graphDataFactory.getData(_this.element.templateData.datasourceElementId, forceUpdateData)
            .then(function (data) {
                if (!Array.isArray(data)) return;
                if (_this.agGridObject == undefined) {
                    /* _this.agGridObject = document.querySelector(_this.myObject);
                    new agGrid.Grid(_this.agGridObject, _this.gridOptions); */
                }

                if (_this.editenabled) {
                    // LIMITAR A 100 REGISTROS
                    _this.data = Array.isArray(data) ? data.slice(0, 100) : data;
                } else {
                    _this.data = data;
                }

                if (Array.isArray(_this.data) && _this.data.length > 0) {
                    makeColumnDefs(_this.data[0]);

                    let savedPrefs = { state: null, filterModel: null };
                    if (_this.edit || restoreEditState) {
                        savedPrefs = { state: cloneColumnState(_this.element.savedState), filterModel: null };
                    } else if (_this.element.id) {
                        const localStorageKey = gridPrefsStorageKey();
                        savedPrefs = _this.getGridPreferencesToRestore(_this.element, localStorageKey);
                        savedPrefs.state = cloneColumnState(savedPrefs.state);
                    }

                    _this.restoringGridPreferences = true;
                    // Configurar columnas
                    _this.gridOptions.api.setColumnDefs(_this.columnDefs);

                    // Esperar a que las columnas estén listas
                    return $timeout(function () {
                        relayoutGrid();
                        _this.gridOptions.api.setRowData(_this.data);

                        return $timeout(function () {
                            if (savedPrefs.state) {
                                try {
                                    _this.gridOptions.columnApi.setState(savedPrefs.state);
                                } catch (e) {
                                    console.error('Error al restaurar estado:', e);
                                }
                            }
                            if (!_this.edit && !restoreEditState && savedPrefs.filterModel) {
                                _this.filterPrefs.prepareRestore(savedPrefs.filterModel);
                                _this.filterPrefs.restoreFromStorage(true);
                            } else {
                                _this.filterPrefs.state.filtersRestored = true;
                            }
                            return $timeout(function () {
                                _this.restoringGridPreferences = false;
                                _this.waitingData = false;
                                _this.updateActiveFiltersState();
                                return $timeout(relayoutGrid, 0);
                            }, 200);
                        }, 150);
                    }, 50);

                } else {
                    _this.gridOptions.api.setRowData([]);
                    _this.waitingData = false;
                    $timeout(relayoutGrid, 0);
                }
            })
            .catch(function (error) {
                console.error('Error cargando datos:', error);
                _this.waitingData = false;
            });
    }

    _this.parseLocalStorageState = function (localStorageKey) {
        try {
            const raw = window.localStorage && window.localStorage[localStorageKey];
            if (!raw) return { state: null, updatedAt: null, filterModel: null };

            const parsed = JSON.parse(raw);
            if (!parsed || typeof parsed !== 'object') return { state: null, updatedAt: null, filterModel: null };

            // Array = formato viejo (estado de columnas directo, sin wrapper)
            if (Array.isArray(parsed)) {
                return { state: parsed, updatedAt: null, filterModel: null };
            }
            // Formato nuevo: { state: [...], updatedAt: "...", filterModel: {...} }
            if (parsed.state != null && typeof parsed.state === 'object') {
                const storedFilter = parsed.hasOwnProperty('filterModel') ? parsed.filterModel : null;
                return {
                    state: parsed.state,
                    updatedAt: parsed.updatedAt || null,
                    filterModel: _this.filterPrefs.hasActiveFilterModel(storedFilter) ?
                        _this.filterPrefs.sanitizeFilterModel(storedFilter) : null
                };
            }
            return { state: parsed, updatedAt: null, filterModel: null };
        } catch (e) {
            return { state: null, updatedAt: null, filterModel: null };
        }
    };

    _this.saveStateToLocalStorage = function (localStorageKey, columnState, updatedAt, filterModel) {
        try {
            if (!window.localStorage || !columnState) return;
            const data = {
                state: columnState,
                updatedAt: updatedAt || new Date().toISOString()
            };
            if (filterModel !== undefined && _this.filterPrefs.hasActiveFilterModel(filterModel)) {
                data.filterModel = _this.filterPrefs.sanitizeFilterModel(filterModel);
            }
            window.localStorage[localStorageKey] = JSON.stringify(data);
        } catch (e) { }
    };

    const stateFromGraph = (element) => {
        if (!element || element.savedState == null) return null;
        if (typeof element.savedState === 'object') return element.savedState;
        if (typeof element.savedState === 'string') {
            try {
                const parsed = JSON.parse(element.savedState);
                return Array.isArray(parsed) || (parsed && typeof parsed === 'object') ? parsed : null;
            } catch (e) {
                return null;
            }
        }
        return null;
    };

    _this.getGridPreferencesToRestore = (element, localStorageKey) => {
        const localData = _this.parseLocalStorageState(localStorageKey);
        const stateFromElement = stateFromGraph(element);
        const elementDateStr = element && element.savedStateUpdatedAt ? element.savedStateUpdatedAt : null;

        if (elementDateStr && localData.updatedAt && localData.state) {
            try {
                const localDate = new Date(localData.updatedAt).getTime();
                const elementDate = new Date(elementDateStr).getTime();
                if (!isNaN(localDate) && !isNaN(elementDate) && localDate < elementDate && stateFromElement) {
                    _this.saveStateToLocalStorage(localStorageKey, stateFromElement, elementDateStr, null);
                    return { state: stateFromElement, filterModel: null };
                }
            } catch (e) { }
        }

        // Formato viejo en localStorage (sin updatedAt, ej. array directo): usar estado del element
        if (localData.state && !localData.updatedAt) {
            if (stateFromElement) {
                _this.saveStateToLocalStorage(localStorageKey, stateFromElement, elementDateStr || undefined, null);
                return { state: stateFromElement, filterModel: null };
            }
            try {
                if (window.localStorage) window.localStorage.removeItem(localStorageKey);
            } catch (e) { }
            return { state: null, filterModel: null };
        }

        if (localData.state) {
            return {
                state: localData.state,
                filterModel: _this.filterPrefs.hasActiveFilterModel(localData.filterModel) ?
                    _this.filterPrefs.sanitizeFilterModel(localData.filterModel) : null
            };
        }
        if (stateFromElement) return { state: stateFromElement, filterModel: null };
        return { state: null, filterModel: null };
    };

    $scope.$on("graph-reloadData-loading", function (event, forceUpdateData) {
        _this.waitingData = true;
    });

    $scope.$on('graph-reloadData', function (event, forceUpdateData) {
        _this.waitingData = true;
        _this.initState = false;
        $timeout(() => _this.loadMe(forceUpdateData), 0);
    });

    $scope.$watch(function () {
        if (!_this.layoutViewport || !_this.layoutViewport.height) {
            return null;
        }
        return (_this.layoutViewport.width || 0) + 'x' + (_this.layoutViewport.height || 0);
    }, function (nv, ov) {
        if (!nv || nv === ov || !ov) {
            return;
        }
        $timeout(function () {
            _this.loadMe(false);
        }, 0);
    });

    if (_this.editenabled != true || (_this.editenabled && _this.edit != true)) {
        $timeout(function () {
            _this.loadMe();
        }, 0);
    }

    // console.log('$scope', $scope)
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            editenabled: '=',
            maximize: '=',
            layoutViewport: '=?',
            graphDomSuffix: '@',
            graphId: '=?'
        },
        replace: true,
        controller: gridGraphCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'gridGraph-directive/gridGraphDirective.html'
    };
};